'use strict';

/**
 * @author Maxim Seredkin
 */

export default function() {
    return {
        restrict: 'A',
        template: require('../view/okved-select.html'),
        transclude: true,
        scope: {
            okved: '=myValue',
            mySize: '=?mySize',
            okveds: '=myOkveds',
            selectedModel: '=selectedModel',
        },
        controller: ['$scope', 'OkvedMultiService',
            function($scope, OkvedService) {
                $scope.select = select;
                $scope.clear = clear;

                // region Function
                function select() {
                OkvedService.select($scope.okveds[0], $scope.okveds).result.then((data) => {
                    const response = data.filter((item, index, arr) => arr.findIndex(n => n.id === item.id) === index).filter((item, index, arr) => !data.some(n => item.parent && (n.id === item.parent.id)))
                    $scope.okveds = response
                });
                }

                function clear() {
                    $scope.okved = null;
                }

                // endregion
        }],
    };
}
